import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StateProvider } from './contexto/store';
import { mainReducer } from './contexto/reducers';
import { initialState } from './contexto/initialState';
import { router } from './router/routes';
import ErrorBoundary from './componentes/ErrorBoundary';
import { AppThemeProvider } from './theme/ThemeProvider'; // <--- New Theme Provider
import { CssBaseline } from '@mui/material'; // <--- Reset CSS globally
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <StateProvider reducer={mainReducer} initialState={initialState}>
          <AppThemeProvider>
            <CssBaseline />
            <RouterProvider router={router} />
          </AppThemeProvider>
        </StateProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
